<script setup lang="ts">
/** A native <dialog> (modal): Escape and click-outside close; focus returns to the opener. */
import { nextTick, onBeforeUnmount, ref, watch } from 'vue';

const props = withDefaults(defineProps<{ open: boolean; labelledby: string; cls?: string }>(), { cls: '' });
const emit = defineEmits<{ close: [] }>();
const el = ref<HTMLDialogElement | null>(null);
let opener: HTMLElement | null = null;

watch(() => props.open, async (open) => {
  await nextTick();
  const d = el.value;
  if (!d) return;
  if (open && !d.open) {
    opener = document.activeElement as HTMLElement | null;
    d.showModal();
  } else if (!open && d.open) {
    d.close();
  }
}, { immediate: true });

function onClose() {
  if (props.open) emit('close');
  const o = opener;
  opener = null;
  requestAnimationFrame(() => {
    if (o && o.isConnected && (document.activeElement === document.body || !document.activeElement)) o.focus({ preventScroll: true });
    else if (document.activeElement === document.body) document.getElementById('panelTitle')?.focus({ preventScroll: true });
  });
}
function onClick(e: MouseEvent) { if (e.target === el.value) emit('close'); }
onBeforeUnmount(() => { if (el.value?.open) el.value.close(); });
</script>

<template>
  <dialog ref="el" :class="['dlg', cls]" :aria-labelledby="labelledby" @close="onClose" @click="onClick">
    <slot v-if="open" />
  </dialog>
</template>
